var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 21.75H15.175M21.125 18.35H18.575M24.95 19.2C24.95 22.4054 24.95 24.0084 23.8917 25.0038C22.8335 25.9991 21.1309 26 17.725 26H17.0679C14.2969 26 12.9097 26 11.9475 25.3217C11.6737 25.1297 11.429 24.8992 11.2208 24.6374C10.5 23.7313 10.5 22.4275 10.5 19.818V17.6547C10.5 15.1362 10.5 13.8765 10.8987 12.8709C11.5395 11.2533 12.8944 9.97835 14.6131 9.37485C15.6807 9 17.0178 9 19.6953 9C21.2236 9 21.9886 9 22.5989 9.2142C23.5806 9.5593 24.355 10.2878 24.7213 11.2117C24.9491 11.7863 24.9491 12.5062 24.9491 13.9453L24.95 19.2Z",
    stroke: "#7A808A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5C10.5 16.7486 10.7985 16.028 11.3298 15.4967C11.8611 14.9654 12.5817 14.667 13.3331 14.667C13.8992 14.667 14.5664 14.7655 15.1163 14.6185C15.3567 14.5538 15.5757 14.4271 15.7516 14.2511C15.9275 14.075 16.054 13.8559 16.1185 13.6155C16.2655 13.0655 16.167 12.3983 16.167 11.8322C16.1672 11.081 16.4658 10.3606 16.997 9.82948C17.5283 9.29836 18.2488 9 19 9",
    stroke: "#7A808A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.28f2ab31aba364774bbf59c558557422.svg";
export { ForwardRef as ReactComponent };